import { FC, ReactNode } from 'react';

import { Box, BoxProps, rem, Tooltip } from '@bonusly/design-system';

const getStyle = (isActive: boolean) => {
	if (isActive) {
		return {
			bg: 'primary.bgAlpha',
			color: 'primary.fgStrong',
			cursor: 'pointer',
			_focusVisible: { outline: '2px solid', outlineColor: 'border.focus', borderRadius: 'md', outlineOffset: '-2px' },
		};
	}

	return {
		bg: 'none',
		color: 'secondary.fg',
		_hover: { bg: 'secondary.bgAlpha' },
		cursor: 'pointer',
		_focusVisible: { outline: '2px solid', outlineColor: 'border.focus', borderRadius: 'md', outlineOffset: '-2px' },
	};
};

type UserNavActionProps = BoxProps & {
	children: ReactNode;
	isActive?: boolean;
	onClick: () => void;
	label?: string;
	isExpanded?: boolean;
};

export const UserNavAction: FC<UserNavActionProps> = ({ children, isActive = false, onClick, label, isExpanded, ...props }) => {
	const actionContent = (
		<Box as="button" type="button" onClick={onClick} w="100%" py={rem(8)} px={rem(10)} borderRadius="md" textAlign="left" {...getStyle(isActive)} {...props}>
			{children}
		</Box>
	);

	return (
		<Tooltip label={label} placement="right" isDisabled={isExpanded || !label}>
			{actionContent}
		</Tooltip>
	);
};
